
import { useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import EditItemForm from "./EditItemForm";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { EditItemDialogProps } from "./EditItemDialog.d";
import { useModalBackButton } from "@/hooks/useModalBackButton";
import { useEditItemData } from "./hooks/useEditItemData";

const EditItemDialog = ({
  isOpen,
  onOpenChange,
  item,
  listId,
  onItemUpdate,
  style
}: EditItemDialogProps) => {
  const { theme } = useThemeConfig();
  const scrollRef = useRef<HTMLDivElement>(null);

  const { handleOpenChange } = useModalBackButton({
    isOpen,
    modalName: "edit-item-dialog",
    onOpenChange
  });

  const { product, categories } = useEditItemData(item);

  if (!item) return null;

  const categoryName =
    item.category === "uncategorized"
      ? "Senza categoria"
      : categories.find(c => c.id === item.category)?.name || "Categoria sconosciuta";

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent
        className="min-h-[45vh] sm:max-w-md z-[5002]"
        scrollRef={scrollRef}
        scrollOptions={{ offsetTop: 120, offsetBottom: 120 }}
        style={{
          borderRadius: theme.borderRadius || '0.5rem',
          backgroundColor: theme.cardBackgroundColor,
          color: theme.sectionTextColor,
          transition: `all ${theme.transitionSpeed || '0.2s'} ease`,
          ...style
        }}>
        <DialogHeader>
          <DialogTitle>{product?.name || "Articolo"}</DialogTitle>
          <DialogDescription style={{ color: theme.sectionTitleColor }}>
            {categoryName}
          </DialogDescription>
        </DialogHeader>
        <EditItemForm
          item={item}
          onOpenChange={onOpenChange}
          onItemUpdate={onItemUpdate || (() => {})}
          style={{
            borderRadius: theme.borderRadius || '0.375rem'
          }}
          listId={listId}
          scrollRef={scrollRef}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditItemDialog;
